import { Code, User } from "lucide-react";

interface DevViewToggleProps {
  isDevView: boolean;
  onToggle: (isDev: boolean) => void;
}

export function DevViewToggle({ isDevView, onToggle }: DevViewToggleProps) {
  return (
    <div className="btn-group">
      <button
        type="button"
        className={`btn btn-sm gap-1.5 ${!isDevView ? "btn-primary" : "btn-outline"}`}
        onClick={() => onToggle(false)}
      >
        <User className="w-3.5 h-3.5" />
        Mes tickets
      </button>
      <button
        type="button"
        className={`btn btn-sm gap-1.5 ${isDevView ? "btn-primary" : "btn-outline"}`}
        onClick={() => onToggle(true)}
      >
        <Code className="w-3.5 h-3.5" />
        Tous (dev)
      </button>
    </div>
  );
}
